var _g, _g2, _g3, _g4, _g5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgShippment = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shippment",
    width: 32.131,
    height: 32.131,
    viewBox: "0 0 32.131 32.131",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M8.033,0a8.033,8.033,0,1,0,8.033,8.033A8.043,8.043,0,0,0,8.033,0Zm4.688,6.237L8.035,11.593a1.342,1.342,0,0,1-.963.457H7.029a1.338,1.338,0,0,1-.947-.392L3.4,8.979A1.339,1.339,0,1,1,5.3,7.086L6.963,8.752l3.743-4.279a1.339,1.339,0,1,1,2.015,1.765Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(6.694 25.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M8.347,19a3.347,3.347,0,1,0,3.347,3.347A3.348,3.348,0,0,0,8.347,19Z",
    transform: "translate(-5 -19)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(22.759 25.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M20.347,19a3.347,3.347,0,1,0,3.347,3.347A3.348,3.348,0,0,0,20.347,19Z",
    transform: "translate(-17 -19)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(2.678 13.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M19.4,11V25.061a1.011,1.011,0,0,1-1,1H13.982a5.4,5.4,0,0,0,.067-.669,4.686,4.686,0,1,0-9.371,0,5.4,5.4,0,0,0,.067.669H3a1.011,1.011,0,0,1-1-1V13.909a10.584,10.584,0,0,0,5.355,1.446A10.7,10.7,0,0,0,16.62,10H18.4A1.011,1.011,0,0,1,19.4,11Z",
    transform: "translate(-2 -10)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(21.421 18.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M20.351,13.55H17a1,1,0,0,0-1,1v9.3a.743.743,0,0,0,.023.111,4.677,4.677,0,0,1,9.349.224,4.61,4.61,0,0,1-.068.669h.4a1,1,0,0,0,1-1V19.909a6.367,6.367,0,0,0-6.359-6.359Z",
    transform: "translate(-16 -13.55)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShippment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shippment.4428a103.svg";
export { ForwardRef as ReactComponent };